import { AUTO_PANEL_SIZE, type PageCmsPanels, type PanelSize } from './panel-types';

/**
 * Sets the size of one panel in a row. Mirrors the legacy editor's `resizeRowPanels`:
 * every panel in the row is reset to "auto" first, then the chosen panel gets the new size,
 * so a 2-panel row can never contain two "wide" panels.
 *
 * Returns a new array; Apollo query results are frozen, so panels must never be mutated in place.
 */
export const updatePanelSize = (
  panels: PageCmsPanels,
  rowIndex: number,
  panelId: string,
  size: PanelSize
): PageCmsPanels =>
  panels.map((row, index) =>
    index === rowIndex
      ? row.map((panel) => ({
          ...panel,
          size: panel.id === panelId ? size : AUTO_PANEL_SIZE
        }))
      : row
  );

/**
 * Removes a panel from a row; a row that becomes empty is removed entirely
 * (the grid never keeps empty rows — drop zones are rendered by the layout, not stored).
 */
export const deletePanel = (panels: PageCmsPanels, rowIndex: number, panelId: string): PageCmsPanels =>
  panels
    .map((row, index) => (index === rowIndex ? row.filter((panel) => panel.id !== panelId) : row))
    .filter((row) => row.length > 0);
